import { PgaPolicy } from "src/shared/models/pga-policy.model";

export class BurialPolicy extends PgaPolicy {}
